import React, { useEffect } from "react";
import Navbar2 from "../Components/Navbar2";
import Footer2 from "../Components/Footer2";
import Aos from "aos";
import { getHireTrainFeature } from "../Common/apis";

function TrainDepoy() {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true // animate only once
    });
  }, []);
  return (
    <>
      <div className="new-home">
        <Navbar2 />
        <div className="flex lg:flex-row flex-col lg:gap-0 gap-[40px] justify-between items-center md:px-[80px] px-[20px] pt-[33px] overflow-hidden">
          <img
            data-aos="fade-right"
            src="/assets/train/item1.svg"
            className="xl:h-auto lg:h-[150px] md:h-[160px]"
            alt=""
          />
          <div data-aos="fade-left" className="t-box">
            <h6 className="md:max-w-[450px] max-w-[282px] w-full font-sans xl:text-[20px] md:text-[16px] text-[14px] md:leading-[24px] leading-[32px] mx-auto text-[#6953A3] md:pt-[20px] pt-[24px] text-center md:pb-[10px] pb-[8px]">
              At GISUL, our Hire-Train-Deploy (HTD)
            </h6>
            <p className="xl:max-w-[400px] max-w-[282px] w-full mx-auto text-center font-sans xl:text-[16px] lg:text-[14px] text-[10px] font-[400] text-[#6953A3]">
              {" "}
              model is designed to bridge the skill gap by transforming both
              fresh graduates and experienced professionals into job-ready
              talent. We carefully recruit high-potential candidates, provide
              them with customized, industry-specific training, and seamlessly
              deploy them into roles that align with your business needs.
            </p>
          </div>
        </div>
        <div className="grid md:grid-cols-2 grid-cols-1 md:gap-[148px] gap-[38px] pt-[34px] md:px-[80px] px-[20px] md:pb-0 pb-[30px]">
          <div className="flex justify-center">
            <img data-aos="fade-left" src="/assets/train/item4.svg" alt="" />
          </div>
          <div>
            <img data-aos="fade-right" src="/assets/a/item1.svg" alt="" />
          </div>
        </div>
        <Footer2 />
      </div>
    </>
  );
}

export default TrainDepoy;
